import { PRESET_FIELDS } from '../../main/reducers/LinkCreatorReducer/utils';
import type { LinkCreatorData } from '../../main/screens/ScreenQuickLinkCreator/types';
export function excludePresetsFromLinkCreatorData(linkCreatorData: LinkCreatorData) {
  const linkCreatorDataExcludingPresets = {};
  Object.keys(linkCreatorData).forEach((key) => {
    if (!PRESET_FIELDS.includes(key)) {
      linkCreatorDataExcludingPresets[key] = linkCreatorData[key];
    }
  });
  return linkCreatorDataExcludingPresets;
}
